<template>
  <div>
    <div>
      <b-row>
        <div class="b-calendar__calendar">
          <div class="border-container" ref="content">
            <div class="border-bottom paddingContainer">
              <span class="month">
                Patient Name:
                <span>
                  {{ selectedPatient.user.first_name | capitalizefirst }}
                  {{ selectedPatient.user.last_name | capitalizefirst }}
                </span>
              </span>
            </div>

            <div class="border-bottom paddingContainer">
              <span class="month">For the month : {{month}}</span>
            </div>

            <div class="b-calendar__weekdays border-bottom">
              <div class="weekday" v-for="(day, index) in days" :key="index">
                <strong>{{day}}</strong>
              </div>
            </div>
            <div class="b-calendar__dates">
              <div
                class="date text-right"
                :class="{
                                'today': date.today,
                                'blank': date.blank,
                                'no-border-right': date.key % 7 === 0,
                             }"
                v-for="date in dateList"
                :key="date.key"
                :data-date="date.date"
                @click="setSelectedDate(date.moment)"
              >
                <span class="day">{{date.dayNumber}}</span>
                <span class="weekday">{{date.weekDay}}</span>
                <div class="additional">
                  <span
                    class="year"
                    :class="{'year-selected':date.iscareplantaken === 'No'}"
                  >{{date.iscareplantaken}}</span>
                  <span class="year" v-show="date.additional.year">{{date.additional.year}}</span>
                  <span class="month" v-show="date.additional.month">{{date.additional.month}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </div>
    <v-loader :isLoading="isLoading" />
  </div>
</template>

<script>
import moment from "moment";
import VLoader from "@/components/loader/index.vue";
import { mapGetters } from "vuex";

export default {
  name: "reportcalendar",
  components: {
    VLoader
  },
  props: {
    dateContext: {
      default: moment()
    },
    selectedPatient: {
      default: Object
    },selection: {
      type: String,
      default: "currentMonth"
    }
  },
  data() {
    return {
      today: moment(),
      selectedDate: moment(),
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    };
  },
  mounted() {
    this.fetchPatientReports();
  },
  computed: {
    ...mapGetters({
      reports: "reports/getPatientByIdReportList",
      isLoading: "reports/getIsPatientByIdIsLoading"
    }),
    year: function() {
      return this.dateContext.format("Y");
    },

    month: function() {
      return this.dateContext.format("MMMM");
    },

    daysInMonth: function() {
      return this.dateContext.daysInMonth();
    },

    currentDate: function() {
      return this.dateContext.get("date");
    },

    firstDayOfMonth: function() {
      let firstDay = moment(this.dateContext).subtract(
        this.currentDate,
        "days"
      );
      return firstDay.weekday();
    },

    previousMonth: function() {
      return moment(this.dateContext).subtract(1, "month");
    },
    previousMonthAsString: function() {
      return this.previousMonth.format("MMMM");
    },
    nextMonth: function() {
      return moment(this.dateContext).add(1, "month");
    },
    nextMonthAsString: function() {
      return this.nextMonth.format("MMMM");
    },

    daysInPreviousMonth: function() {
      return this.previousMonth.daysInMonth();
    },
    daysFromPreviousMonth: function() {
      let daysList = [];
      let count = this.daysInPreviousMonth - this.firstDayOfMonth;
      while (count < this.daysInPreviousMonth) {
        count++;
        daysList[count] = count;
      }

      return daysList.filter(function() {
        return true;
      });
    },
    dateList: function() {
      let $this = this;

      let dateList = [];

      let previousMonth = this.previousMonth;
      let nextMonth = this.nextMonth;

      //dates for display
      let formattedCurrentMonth = this.dateContext.format("MM");
      let formattedCurrentYear = this.year;
      let formattedPreviousMonth = previousMonth.format("MM");
      let formattedPreviousYear = previousMonth.format("Y");
      let formattedNextMonth = nextMonth.format("MM");
      let formattedNextYear = nextMonth.format("Y");

      //counters
      let countDayInCurrentMonth = 0;
      let countDayInPreviousMonth = 0;

      //filling in dates from the previous month
      this.daysFromPreviousMonth.forEach(function(dayFromPreviousMonth) {
        countDayInCurrentMonth++;
        countDayInPreviousMonth++;

        let formattedDay = $this.formattingDay(dayFromPreviousMonth);
        let previousMonth =
          $this.daysFromPreviousMonth.length === countDayInPreviousMonth
            ? $this.previousMonthAsString
            : false;
        let previousYear =
          formattedCurrentYear !== formattedPreviousYear &&
          $this.daysFromPreviousMonth.length === countDayInPreviousMonth
            ? formattedPreviousYear
            : false;
        let additional = {
          month: previousMonth,
          year: previousYear
        };

        if (!previousMonth && !previousYear) {
          additional = false;
        }

        dateList[countDayInCurrentMonth] = {
          key: countDayInCurrentMonth,
          dayNumber: formattedDay,
          date:
            formattedDay +
            "." +
            formattedPreviousMonth +
            "." +
            formattedPreviousYear,
          blank: true,
          today: false,
          additional: additional,
          weekDay: false,
          moment: moment(
            formattedPreviousYear + formattedPreviousMonth + formattedDay
          )
        };
      });

      //filling in dates from the current month
      while (countDayInCurrentMonth < this.firstDayOfMonth + this.daysInMonth) {
        countDayInCurrentMonth++;

        let day = countDayInCurrentMonth - countDayInPreviousMonth;
        let weekDay = this.getWeekDay(countDayInCurrentMonth);
        let formattedDay = this.formattingDay(day);
        let iscareplantaken = "--";
        let  index = day -1;
         
        if(this.reports.length > 0&&index < this.reports.length){
          if(this.reports[index].total_intervention == 0&&this.reports[index].intervention_progress == 0){
            iscareplantaken = "--"
          }else if(this.reports[index].total_intervention == this.reports[index].intervention_progress){
               iscareplantaken = "Yes"
          }else if(this.reports[index].intervention_progress == 0){
            iscareplantaken = "--"
          }else{
            iscareplantaken = "No"
          }
          
        }
      
        dateList[countDayInCurrentMonth] = {
          key: countDayInCurrentMonth,
          dayNumber: formattedDay,
          iscareplantaken: iscareplantaken,
          date:
            formattedDay +
            "." +
            formattedCurrentMonth +
            "." +
            formattedCurrentYear,
          blank: false,
          today:
            formattedDay === this.initialDate &&
            this.todayInCurrentMonthAndYear,
          additional: false,
          weekDay: weekDay,
          moment: moment(
            formattedCurrentYear + formattedCurrentMonth + formattedDay
          )
        };
      }

      let daysInNextMonth = 7 - (countDayInCurrentMonth % 7);
      let countDayInCurrentMonthSaved = countDayInCurrentMonth;
      let day = 0;

      //filling in dates from the next month
      if (daysInNextMonth < 7) {
        while (
          countDayInCurrentMonth <
          countDayInCurrentMonthSaved + daysInNextMonth
        ) {
          countDayInCurrentMonth++;
          day++;

          let formattedDay = this.formattingDay(day);
          let nextMonth = day === 1 ? this.nextMonthAsString : false;
          let nextYear =
            formattedCurrentYear !== formattedNextYear && day === 1
              ? formattedNextYear
              : false;
          let additional = {
            month: nextMonth,
            year: nextYear
          };

          if (!nextMonth && !nextYear) {
            additional = false;
          }

          dateList[countDayInCurrentMonth] = {
            key: countDayInCurrentMonth,
            dayNumber: formattedDay,
            date:
              formattedDay + "." + formattedNextMonth + "." + formattedNextYear,
            blank: true,
            today: false,
            additional: additional,
            weekDay: false,
            moment: moment(
              formattedNextYear + formattedNextMonth + formattedDay
            )
          };
        }
      }

      return dateList.filter(function() {
        return true;
      });
    },
    initialDate: function() {
      return this.formattingDay(this.today.get("date"));
    },
    initialMonth: function() {
      return this.today.format("MMMM");
    },
    initialYear: function() {
      return this.today.format("Y");
    },
    todayInCurrentMonthAndYear: function() {
      return this.month === this.initialMonth && this.year === this.initialYear;
    }  
  },
  methods: {
    fetchPatientReports() {
      const startOfMonth = moment(this.dateContext).startOf('month').format('YYYY-MM-DD');
      const endOfMonth   = moment(this.dateContext).endOf('month').format('YYYY-MM-DD');
      this.$store.dispatch(
        "reports/getPatientReportById",
         {id:this.selectedPatient.id,selection:this.selection,startdate:startOfMonth,enddate:endOfMonth},
      );
    },
    setSelectedDate: function(moment) {
      this.selectedDate = moment;
    },
    formattingDay(day) {
      return ("0" + day).slice(-2);
    },
    getWeekDay(day) {
      let index = day;
      if (index > 7) {
        index %= 7;
      }
      index = index === 0 ? 6 : index - 1;
      return this.days[index];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./calendar.scss";
</style>